'use strict';

export const defaultState = () => ({});

export const state = () => defaultState();

export const getters = {};

export const mutations = {};

export const actions = {
    get() {
        return this.$axios.$get(`/terms-of-use`);
    }
};

export default {
    state,
    getters,
    mutations,
    actions
};
